import { Theme } from "@emotion/react";
import { Components, CssVarsTheme } from "@mui/material";
import { MuiFormLabel, MuiInputLabel } from "./form-label";
import { MuiTextField } from "./text-field";
import { MuiSvgIcon } from "./icon";
import { MuiButton } from "./button";
import { MuiTab, MuiTabs } from "./tabs";
import { MuiSelect } from "./select";
import { MuiTableCell, MuiTableHead, MuiTableRow } from "./table";
import { MuiChip } from "./chip";
import { MuiContainer } from "./container";
import { MuiDialog } from "./dialog";
import { MuiBreadcrumbs } from "./breadcrumb";
import { MuiBadge } from "./badge";
import { MuiMenu, MuiMenuItem } from "./menu";
import { MuiDivider } from "./divider";
import { MuiSwitch } from "./switch";
import { MuiPopover } from "./popover";
import { MuiTooltip } from "./tooltip";
import { MuiInputAdornment } from "./input-adornment";
import { MuiToggleButtonGroup, MuiToggleButton } from "./toggle-button-group";

export const components: Components<Omit<Theme, "components" | "palette"> & CssVarsTheme> = {
  MuiFormLabel,
  MuiInputLabel,
  MuiTextField, 
  MuiSvgIcon,
  MuiButton,
  MuiTabs,
  MuiTab,
  MuiSelect,
  MuiTableHead,
  MuiTableRow,
  MuiTableCell,
  MuiChip,
  MuiContainer,
  MuiDialog,
  MuiBreadcrumbs,
  MuiBadge,
  MuiMenu,
  MuiMenuItem,
  MuiPopover,
  MuiDivider,
  MuiSwitch,
  MuiTooltip,
  MuiInputAdornment,
  MuiToggleButtonGroup,
  MuiToggleButton,
}